<h1 class="text-dark text-xl" mat-dialog-title>Assicurazione</h1>
<div class="w-full" mat-dialog-content>
  <app-rental-insurance-form
    (closeDialogEvent)="closeDialog()"
    [data]="data.insurance"
    [practiceRentalId]="data.id"
  ></app-rental-insurance-form>
</div>
